import {defineStore} from 'pinia';
import {toRaw} from "vue";

export const useSearchStore = defineStore('search', {
    state: () => ({
        searchQuery: null,
        customResultIndex: 0,
        minCustomResultIndex: -1,
        quickResults: [],
        maxCustomResultIndex: 0,
        clickedOutside: false,
        selectedFacet: null,
    }),
    actions: {
        incrementCustomResultIndex() {
            this.customResultIndex++;
            this.maxCustomResultIndex = this.customResultIndex;
            return this.customResultIndex;
        },
        changeSelectedFacet(facet) {
            this.selectedFacet = facet;
        },
    }
});
